// "& more" payment sheet (snippets/mlb-payment-icons.liquid). The popover opens natively (popovertarget) and its
// entry animation is CSS. This module adds what mobile browsers don't do reliably on their own:
// - an animated close: the dimmed area, ✕ and Escape play the exit animation, then hide the popover
// - focus on ✕ once the sheet opens, without scrolling (autofocus scrolled the page on iOS while the sheet was
//   still below the screen at the start of its slide)
// - Escape closes only the sheet: inside the bag, Horizon's dialog takes Escape first and would close the bag

const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
const EXIT_ANIMATIONS = ['mlb-sheet-down', 'mlb-sheet-sink'];

/** @param {Element} sheet */
const isOpen = (sheet) => {
  try {
    return sheet.matches(':popover-open');
  } catch {
    return sheet.classList.contains(':popover-open');
  }
};

/** @param {HTMLElement} sheet */
function closeSheet(sheet) {
  if (!isOpen(sheet) || sheet.hasAttribute('data-closing')) return;

  const panel = sheet.querySelector('.mlb-pay-sheet__panel');
  if (reduceMotion.matches || !(panel instanceof HTMLElement)) {
    sheet.hidePopover();
    return;
  }

  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    clearTimeout(fallback);
    panel.removeEventListener('animationend', onEnd);
    if (isOpen(sheet)) sheet.hidePopover();
  };
  /** @param {AnimationEvent} event */
  const onEnd = (event) => {
    if (event.target === panel && EXIT_ANIMATIONS.includes(event.animationName)) finish();
  };
  // In case the exit animation never runs (a style override, a background tab)
  const fallback = setTimeout(finish, 450);

  panel.addEventListener('animationend', onEnd);
  sheet.setAttribute('data-closing', '');
}

document.addEventListener(
  'click',
  (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-mlb-sheet-close]') : null;
    const sheet = button?.closest('.mlb-pay-sheet');
    if (!(sheet instanceof HTMLElement)) return;

    // Cancels the button's popovertarget hide, which would cut the exit animation
    event.preventDefault();
    closeSheet(sheet);
  },
  { capture: true }
);

// toggle doesn't bubble, so listen in the capture phase
document.addEventListener(
  'toggle',
  (event) => {
    const sheet = event.target;
    if (!(sheet instanceof HTMLElement) || !sheet.classList.contains('mlb-pay-sheet')) return;

    if (/** @type {ToggleEvent} */ (event).newState === 'open') {
      sheet.querySelector('.mlb-pay-sheet__close')?.focus({ preventScroll: true });
    } else {
      // Closed some other way (Android back) while the exit animation ran
      sheet.removeAttribute('data-closing');
    }
  },
  { capture: true }
);

window.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape') return;

    const sheet = [...document.querySelectorAll('.mlb-pay-sheet')].find(isOpen);
    if (!(sheet instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();
    closeSheet(sheet);
  },
  { capture: true }
);
